import React from "react"
import {CompositeFilterDescriptor, filterBy, FilterDescriptor} from "@progress/kendo-data-query"
import {ComboBoxChangeEvent, ComboBoxFilterChangeEvent, ListItemProps} from "@progress/kendo-react-dropdowns"
import {Field} from "@progress/kendo-react-form"
import {RootState} from "../../../rootReducer"
import {useAppSelector} from "../../../store"
import BookingMultiColumnComboBox from "../../Shared/multiColumnComboBox"

const BKTestCodeComboBox = ({
    bookingID,
    testPackageID,
    onChange,
}: {
    bookingID: number
    testPackageID: number | null
    onChange: (ev: ComboBoxChangeEvent) => void
}) => {
    const loadingTestCodes = useAppSelector((state: RootState) => state.containers.motBooking.gettingTestCodes)
    const testsData = useAppSelector((state: RootState) => state.containers.motBooking.testsData)

    const [filter, setFilter] = React.useState<CompositeFilterDescriptor>()

    const columns = [
        {
            field: "testCode",
            header: "Code",
            width: "150px",
        },
        {
            field: "testName",
            header: "Name",
            width: "500px",
        },
    ]

    const columnItemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const children = columns.map((col, i) => {
            return (
                <span className="k-table-td" style={{width: col.width}} key={i}>
                    {itemProps.dataItem[col.field]}
                </span>
            )
        })
        return React.cloneElement(li, {...li.props}, children)
    }

    const onFilterChange = (event: ComboBoxFilterChangeEvent) => {
        if (event) {
            const filters = [
                {field: "testCode", operator: "contains", value: event.filter.value},
                {field: "testName", operator: "contains", value: event.filter.value},
            ] as Array<FilterDescriptor>
            setFilter({logic: "or", filters})
        }
    }
    //const disabled = bookingID === 0 && ((testPackageID !== null && testPackageID > 0) as boolean)

    return (
        <>
            <Field
                //disabled={disabled}
                required={false}
                name={"testCode"}
                component={BookingMultiColumnComboBox}
                textField="testCode"
                dataItemKey="testCode"
                data={filter ? filterBy(testsData, filter) : testsData}
                label={"Test Type"}
                filterable={true}
                loading={loadingTestCodes}
                columns={columns}
                itemRender={columnItemRender}
                onFilterChange={onFilterChange}
                onChange={onChange}
            />
        </>
    )
}

export default BKTestCodeComboBox
